import React from 'react'
import DashboardPanel from "./DashboardPanel";
import {Link} from "react-router-dom";
import ScrollArea from "react-scrollbar";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {Badge, Empty} from "antd";
import ErrorBanner from "../../../components/ErrorBanner";


export default class TeamsPanel extends DashboardPanel {
    // static header ='talent.dashboard.teams_title';
    static header = 'Teams';

    static is_active = true;

    isDisabled() {
        if (this.props.disabled) {
            return true;
        }
        if (this.context?.auth?.canManageClientResourceTalent() || this.context?.auth?.isTalentSupplierResource()) {
            return false;
        }
        return !this.context?.auth?.isProfileApproved()
    }

    disabledReason() {
        return this.props.disabledReason || 'Your profile must be complete and your submission accepted in create/manage teams.';
    }

    renderPanelHeader(title, totalUpdates, daysSinceUpdated)
    {
        if(!title) {
            title = this.props.title || TB.tryTrans(this.constructor.header);
        }
        if(!totalUpdates) {
            totalUpdates = this.props.totalUpdates;
        }
        if (!TB.isDefined(daysSinceUpdated)) {
            daysSinceUpdated = this.daysSinceUpdated()
        }
        const teamType = this.context?.auth?.canManageClientResourceTalent?.() ? 'supplier' : 'talent';

        return (
            <div className="header-content">
                <div>
                    <Badge count={parseInt(totalUpdates) || 0}>
                        <h1 className="dashboard-title">
                            {title}
                        </h1>
                    </Badge>


                    {TB.isInteger(daysSinceUpdated) && (
                        <div className="header-last-updated static -mt-1.5">
                            <p className={daysSinceUpdated > 30 ? 'text-danger' : ''}>
                                <i className="fas fa-clock"/>
                                &nbsp; {`${daysSinceUpdated} day${(daysSinceUpdated === 1) ? '' : 's'} ago`}
                            </p>
                        </div>
                    )}

                </div>

                {!this.props.disabled && this.props.teams?.length > 0 && (
                    <Link to={`/${teamType}/teams/all`} className="btn btn-primary ml-auto self-center">
                        View Teams
                    </Link>
                )}
            </div>
        )
    }

    renderPanelContent() {
        const {teams, isLoading, error} = this.props;

        const teamType = this.context?.auth?.canManageClientResourceTalent?.() ? 'supplier' : 'talent';

        return (
            <div className="talent-panel-content-container">

                {(!isLoading && !error && teams) ? (
                    teams?.length > 0 ? (
                        <div className="opportunity-list flex-grow">
                            <div className="opportunity-list-section flex-grow">
                                <div className="opportunity-list-items flex-grow">
                                    <ScrollArea
                                        speed={0.8}
                                        className="area min-h-[325px] max-h-[325px]"
                                        smoothScrolling={false}
                                        contentClassName="scroll-area"
                                        stopScrollPropagation={true}
                                        horizontal={false}
                                    >
                                        {
                                            TB.orderBy(teams, ['is_invite'], ['asc']).map(team => {
                                                return (
                                                    <Link
                                                        key={team.id}
                                                        to={team.is_invite ? `/${teamType}/teams/invited`: `/${teamType}/team/manage/${team.id}`}
                                                        className="opportunity-list-item px-2"
                                                    >
                                                        <div className="flex items-center">
                                                            <img
                                                                src={team.banner_image_path || TB.defaultTalentBannerImage()}
                                                                className="h-10 w-10 rounded-full object-cover"
                                                            />

                                                            <div className="pl-2 flex justify-between w-full items-center">
                                                                <p className="font-bold">{team.name}</p>
                                                                {team.is_invite && (
                                                                    <Badge status="success" count={"New Invite!"}/>
                                                                )}
                                                                <p className="text-xs">{team.positions_count} Members</p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                )
                                            })
                                        }
                                    </ScrollArea>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Empty
                            className="flex flex-col items-center justify-center flex-grow"
                            image="/images/heads.png"
                            imageStyle={{height: 60}}
                            description={(
                                <div className="flex flex-col gap-2 items-center justify-center">
                                    <p className="text-lg">
                                        No Teams Yet
                                    </p>
                                    <p className="text-sm">
                                        Form teams to deliver projects with people you already know and love
                                        working with.
                                    </p>
                                </div>
                            )}>

                            {!this.context?.auth?.isTalentSupplierResource() && (
                                <Link to={`/${teamType}/team/setup`} className="mx-auto btn btn-primary font-sm">
                                    Create New Team
                                </Link>
                            )}
                        </Empty>
                    )
                ) : (
                    <div className="flex-grow items-center justify-center flex flex-col">
                        {isLoading ? <LoadingSpinner size={'lg'}/> : (
                            error && <ErrorBanner onRetry={this.props.refetch || undefined}/>
                        )}
                    </div>
                )}
            </div>
        )
    }
}